import React, { useEffect, useState } from 'react'
import { Select, Checkbox } from '@arnsbogroup/react-voicearchive'
import SupplierAvailabilityDataTable from './components/SupplierAvailabilityDataTable'
import TimeRange from 'components/TimeRange'
import SupplierTurnaround from 'components/SupplierTurnaround'
import { FormattedMessage } from "react-intl";
import messages from "./messages";


const SupplierAvailability = ( {supplier, onChangeHandler, currentUser} ) => {
    if (!supplier) {
        return null
    }

    return (
        <div className='p-4'>
            <SupplierTurnaround
                supplierId={supplier?.uid}
            />
            <div>
                <div className='font-medium text-gray-700 space-y-1 mb-1'>
                    <div>
                        <label className='text-sm'>
                            <FormattedMessage {...messages.unAvailabilityAndBookings} />
                        </label>
                    </div>
                    <div>
                        <label className='font-normal text-xs'>
                            <FormattedMessage {...messages.unAvailabilityAndBookingsDescription} />
                        </label>
                    </div>
                </div>
                <SupplierAvailabilityDataTable supplierId={supplier.uid} />
            </div>
        </div>
    )
}

export default SupplierAvailability
